import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import type {
  InitiateTrainingRunDownloadsMutation,
  InitiateTrainingRunDownloadsMutationVariables,
} from '@sbrc/gql/apollo-codegen';

const INITIATE_DOWNLOADS = gql`
  mutation InitiateTrainingRunDownloads(
    $input: InitiateTrainingRunDownloadsInput!
  ) {
    initiateTrainingRunDownloads(input: $input) {
      success
    }
  }
`;

const DEFAULT_DOWNLOAD_PATH = '/models';

export function useInitiateDownload(robotId: string | null) {
  const [mutate] = useMutation<
    InitiateTrainingRunDownloadsMutation,
    InitiateTrainingRunDownloadsMutationVariables
  >(INITIATE_DOWNLOADS);

  const initiateDownload = useCallback(
    async (trainingRunId: string) => {
      if (!robotId) return;

      await mutate({
        variables: {
          input: {
            trainingRunId,
            robotIds: [robotId],
            downloadPath: DEFAULT_DOWNLOAD_PATH,
          },
        },
        // Refetch the training runs query so the UI picks up the new
        // pending row immediately (downloads are a field on TrainingRun),
        // which also wakes the Versions tab's polling loop.
        refetchQueries: ['GetSkillTrainingRuns'],
      });
    },
    [robotId, mutate],
  );

  return { initiateDownload };
}
